import { Helmet } from "react-helmet-async";

const SITE = "https://bbrgo.fr";
const DEFAULT_IMG = `${SITE}/logo-bbrgo.png`;

export function Seo({ title, description, path = "", noindex = false, image, type = "website", jsonLd }) {
  const url = `${SITE}${path}`;
  const img = image || DEFAULT_IMG;
  return (
    <Helmet>
      <html lang="fr" />
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="BBR.GO" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
